module.exports = "/_next/static/images/b0e8fd88645ff0a70feeb4f2cd8dfb9f-people-smile-at-home-lg@1x.jpg";